import { Component, Input, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AppService } from '../app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ResetpasswordComponent } from '../resetpassword/resetpassword.component';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MsalService } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { messageService } from '../message.service';

@Component({
  selector: 'app-loginnon-ad',
  templateUrl: './loginnon-ad.component.html',
  styleUrls: ['./loginnon-ad.component.scss']
})
export class LoginnonADComponent {
  isProcessing: boolean = false;

  orgDetail: any;
  private msalInstance: IPublicClientApplication;

  dashboard() {
    this.router.navigate(['/dashboard'])
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }


  showUserName() {
    this.changetypeAddAndEdituSER = !this.changetypeAddAndEdituSER;
  }

  oneQmsOrgImagesDetails: any = {};
  @Input() redirectTo: string = "/dashboard"
  title = 'angular-demo';
  loading = false;
  constructor(private authService: MsalService, private appService: AppService, private router: Router, private dialog: MatDialog, private snackBar: MatSnackBar, private message: messageService) {
    //const msalInstance = authService.instance;


    this.appService.getAllOrgReportImages().subscribe((response1: any) => {
      this.oneQmsOrgImagesDetails = response1;
      console.log(this.oneQmsOrgImagesDetails);
    })


    console.log(this.authService.instance)
    this.onLogin();
  }
  closesnackbar() {
    //console.log("outside");
    this.snackBar.dismiss();
  }


  onLogin() {
    // Fetch the user's IP address
    this.appService.getIpAddress().subscribe((data: any) => {
      this.ipAddress = data.ip; // IP address from the API response

      // Now you can send the login details and IP address to your backend
      console.log('User IP Address:', this.ipAddress);

      // Proceed with login (this is just an example, modify as needed)

    }, error => {
      console.error('Error fetching IP address', error);
    });
  }
  public href: string = "";
  data1: any;
  changetypeAddAndEdituSER: boolean = false;
  showEyeIconForUserName: boolean = false;
  ngOnInit() {



    this.href = this.router.url;
    //console.log(location.origin);
    console.log(location);
    //const data1={applicationUrl:"https://predev.one-qms.com/clinevo"}
    const fullpath = location.pathname;
    const splitedPath = fullpath.split("/");
    if (splitedPath.length > 1) {
      splitedPath[1]
    }


    // if(location.href=="http://localhost:4200/login"){
    //   this.data1 ={
    //     applicationUrl:"https://predev.one-qms.com/login/demo"
    //   }
    // }else{
    this.data1 = {
      applicationUrl: localStorage.getItem("adapplicationUrl")!,
    }
    //}
    console.log(this.data1);
    this.loading = true;
    this.appService.orgDetails(this.data1).subscribe((data: any) => {

      this.message.orgData = data;
      this.orgDetail = data;
      this.showEyeIconForUserName = this.orgDetail.hideUserName == 'Y';
      function delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
      this.userSettings['orgName'] = this.orgDetail.orgShortName;
    });
    //console.log(location.pathname);
  }
  inputText: boolean;
  inputPassword: boolean;
  focusFunction(type: String) {
    if (type == "text") {
      this.inputText = false;
      this.inputPassword = true;
    } else if (type == "pw") {
      this.inputText = false;
      this.inputPassword = true;
    }
  }
  //show hide div variables
  userlogin = true;
  userregister = false;
  organisationName = false;
  forgotPassword = false;
  user_register() {
    this.userlogin = false;
    this.userregister = true;
    this.forgotPassword = false;
  }
  user_login() {
    this.userlogin = true;
    this.userregister = false;
    this.forgotPassword = false;
  }
  forgot_Password() {
    this.forgotPassword = true;
    this.userlogin = false;
    this.userregister = false;
  }
  ipAddress: any;
  userSettings: any = {
    orgName: null,
    password: null,
    userName: null,
    emailAddress: null,
    //tokenId:32156987,
    overridesession: "N",
    isViewMode: "N",
    ipAddress: null
  }
  dialogRef: any;
  loginNonAd: boolean;

  userData() {
    const userName = this.userSettings.userName.toUpperCase()
    this.appService.userDetailsByName(userName).subscribe((data: any) => {
      localStorage.setItem("userName", data[0].userName + ", " + data[0].userName);
      localStorage.setItem("email", data[0].emailAddress);
      console.log("email ", data[0].email);
      this.message.setUserId(data[0].userId);
      localStorage.setItem("userprofilename", data[0].lastName + " , " + data[0].firstName);
      localStorage.setItem("loggedUserName", userName);

      localStorage.setItem("timezone", data[0].timezone);

      console.log(localStorage.getItem("userprofilename"));
      localStorage.setItem("loginMode", "Editable");
      localStorage.setItem("adEnabled", "N");
      this.loginNonAd = true;
      localStorage.setItem("loginNonAd", "Y");
      this.router.navigate(['/dashboard']);

      //this.loading=false;
    })
  }

  authEnable() {
    // this.authService.loginRedirect().subscribe((response) => {
    //   // Handle login response if needed

    //   console.log(response)
    // });

    // if (this.msalGuardConfig.authRequest){
    //   this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    // } else {
    //   this.authService.loginRedirect();
    // }

    //  this.authService.loginRedirect();

  }
  loginbtn() {


    localStorage.setItem("loginMode", "Editable");
    localStorage.setItem("orgName", this.userSettings['orgName']);
    this.userSettings.ipAddress = this.ipAddress;
    this.loading = true;
    this.isProcessing = true;
    this.appService.loginUser(this.userSettings).subscribe((data: any) => {
      this.message.setOrgId(data.IP_ORG_ID);

      this.loading = false;
      this.isProcessing = false;
      localStorage.setItem("loginNonAd", "Y");
      if (data.RESULT_TYPE_KEY == 'PW' && data.RESULT_KEY.includes('password expired')) {

        this.dialogRef = this.dialog.open(ResetpasswordComponent, {
          // disableClose: false,
          width: '500px',
          data: {
            message: data.RESULT_KEY,
            userDetails: this.userSettings,
            orgId: this.message.getOrgId(),
          }

        });
        this.dialogRef.afterClosed().subscribe((result: { [x: string]: string; }) => {
          if (result['event'] == 'add') {
            this.loading = true;
            //console.log(result);
          }
        });
      }
      // else if(data.RESULT_TYPE_KEY=='UW' && data.RESULT_KEY.includes('has another active session')){
      else if (data.RESULT_TYPE_KEY == 'UW') {
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          // disableClose: false,
          //width: '900px',
          data: {
            message: data.RESULT_KEY,
          }

        });
        this.dialogRef.afterClosed().subscribe((result: { [x: string]: string; }) => {
          if (result['event'] == 'override') {
            this.loading = true;
            console.log(result);
            this.userSettings.overridesession = "Y";
            this.userSettings.isViewMode = "N";
            this.appService.loginUser(this.userSettings).subscribe((data: any) => {

              if (data.RESULT_TYPE_KEY == 'E') {
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: data.RESULT_TYPE_KEY == 'S' ? "User logged in sucessfully" : data.RESULT_KEY,
                    type: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
              } else if (data.RESULT_TYPE_KEY == "S") {
                localStorage.setItem("tokenId", data.IOP_TOKEN_ID);
                if (data.OP_CLEARCACHE == "Y") {
                  this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig);
                }
                this.userData();

                //this.router.navigateByUrl(this.redirectTo);
              }
              this.loading = false;
            })
          } else if (result['event'] == 'view') {
            console.log(result);
            this.loading = true;
            this.userSettings.overridesession = "N";
            this.userSettings.isViewMode = "Y";
            this.appService.loginUser(this.userSettings).subscribe((data: any) => {

              if (data.RESULT_TYPE_KEY == 'E') {
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: data.RESULT_TYPE_KEY == 'S' ? "User logged in sucessfully" : data.RESULT_KEY,
                    type: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
              } else if (data.RESULT_TYPE_KEY == "S") {
                localStorage.setItem("tokenId", data.IOP_TOKEN_ID);
                if (data.OP_CLEARCACHE == "Y") {
                  this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig);
                }
                this.userData();
                // this.router.navigate(['/dashboard']);
                //this.router.navigateByUrl(this.redirectTo);

              }
              this.loading = false;
            })
          }
        });
      } else if (data.RESULT_TYPE_KEY == 'E') {
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          data: {
            message: data.RESULT_TYPE_KEY == 'S' ? "User logged in sucessfully" : data.RESULT_KEY,
            type: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          //duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      } else if (data.RESULT_TYPE_KEY == "S") {
        localStorage.setItem("tokenId", data.IOP_TOKEN_ID);
        if (data.OP_CLEARCACHE == "Y") {
          this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig);
        }
        this.userData();

        // this.router.navigate(['/dashboard']);
        //this.router.navigateByUrl(this.redirectTo);
      } else if (data.RESULT_TYPE_KEY == "UWy") {

      }

    })
  }
  send_forgot_Password() {
    this.appService.forgotPassword(this.userSettings).subscribe((data: any) => {

      if (data.RESULT_TYPE_KEY == 'S' || data.RESULT_TYPE_KEY == 'E') {
        if (data.RESULT_TYPE_KEY == "S") {
          this.userSettings.userName = null;
          this.userSettings.password = null;
          this.userSettings.emailAddress = null;
          this.userSettings.orgName = null;
        }
      }
      this.showSnackBar(data.RESULT_KEY, data.RESULT_TYPE_KEY);
      this.loading = false;
    })
  }
  unregister() {
  }
  reset() {

  }
  onFocusOutEvent(event: any) {
    this.organisationName = false;
  }

  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;
  visibleConfirmationPopup: MatDialogRef<TemplateRef<any>>;


  confirmationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  okConfirmation() {
    window.location.reload();
    this.visibleConfirmationPopup.close();
  }

  cancelConfirmation() {
    this.visibleConfirmationPopup.close();
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

}
